import { baseApi } from 'segments/api/baseApi';

import { adapteCoachesList } from '../utils/adapter';
import { transformCouchInfo } from '../utils/transformer';

import type {
  UpdateCoachParams,
  CoachesList,
  CreateCoachParams,
} from './types';

export const api = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCoachesList: builder.query<CoachesList, void>({
      query: () => ({
        url: '/admin/coaches/list',
        method: 'GET',
      }),
      transformResponse: adapteCoachesList,
      providesTags: ['CoachesList'],
      keepUnusedDataFor: 1,
    }),

    createCoach: builder.mutation<unknown, CreateCoachParams>({
      query: (formData: CreateCoachParams) => ({
        url: '/admin/coaches/create',
        method: 'POST',
        body: transformCouchInfo(formData)
      }),
      invalidatesTags: ['CoachesList','CoachesBooking'],
    }),

    deleteCoach: builder.mutation<unknown, number>({
      query: (id: number) => ({
        url: `/admin/coaches/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CoachesList','CoachesBooking'],
    }),

    updateCoach: builder.mutation<unknown, UpdateCoachParams>({
      query: ({ id, ...formData }: UpdateCoachParams) => ({
        url: `/admin/coaches/update/${id}`,
        method: 'PUT',
        body: transformCouchInfo(formData),
      }),
      invalidatesTags: ['CoachesList','CoachesBooking'],
    })
  }),
});

export const {
  useGetCoachesListQuery,
  useUpdateCoachMutation,
  useDeleteCoachMutation,
  useCreateCoachMutation
} = api;
